class FieldValidation {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.validateFields = document.querySelector('[data-save-button]');
        self.field = self.elem.querySelector('[data-validate-field]');
        self.validationMessage = self.elem.querySelector('[data-validation-message]');
        self.checkbox = self.elem.querySelector('[data-checkbox]');
    }

    init() {
        let self = this;

        self.validateFields.addEventListener('click', (evt) => {
            evt.preventDefault();

            if (self.field) {
                if (self.field.required) {
                    self.validateField();
                }
            }
        });

        if (self.checkbox) {
            self.checkboxLimit = self.checkbox.getAttribute('data-checkbox-limit');
            if(self.checkboxLimit > 0 ){
                self.checkBoxMaxSelect();
            }
        }
    }

    validateField() {
        let self = this;

        const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const inputText = self.field.value.trim();

        if (self.field.type == 'email') {
            if (inputText.match(emailFormat)) {
                self.validationMessage.classList.add('d-none');
                self.field.classList.remove('is-invalid');

                return true;
            } else {
                self.validationMessage.classList.remove('d-none');
                self.validationMessage.innerText = 'Please check your email address';
                self.field.classList.add('is-invalid');

                return false;
            }
        }

        if (inputText !== '') {
            self.validationMessage.classList.add('d-none');
            self.field.classList.remove('is-invalid');

            return true;
        } else {
            self.validationMessage.classList.remove('d-none');
            self.validationMessage.innerText = `${self.field.dataset.label} is a required field`;
            self.field.classList.add('is-invalid');

            return false;
        }
    }

    checkBoxMaxSelect(){
        let self = this;

        var limit = 3;
        var checkboxes = self.elem.querySelectorAll('input[data-multiple-checkbox]');

        checkboxes.forEach(function(checkbox) {

            checkbox.addEventListener('change', function(evt) {
                var checkedCheckboxes = self.elem.querySelectorAll('input[data-multiple-checkbox]:checked');

                if (checkedCheckboxes.length > self.checkboxLimit) {
                    this.checked = false;
                }
            });
        });
    }
}

export default FieldValidation;
